import styled from 'styled-components'
import logo from '../../images/logo.png'

const Container = styled.footer`
  background: #1a1a1a;
  padding: 50px;
  margin-top: 50px;
  display: flex;
  justify-content: center;
`
const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
`
const Item = styled.ul`
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
`
const Title = styled.h4`
  margin: 0;
  margin-bottom: 50px;
  font-size: 21px;
`
const LinkItem = styled.a`
  margin-bottom: 20px;
  color: inherit;
  text-decoration: none;
  width: fit-content;

  &:hover {
    border-bottom: 1px solid #fff;
  }
`
const Copyright = styled.span``
const Disclaimer = styled.span`
  font-size: 12px;
  opacity: 0.5;
  margin-top: 10px;
  max-width: 200px;
  line-height: 1.5;
`
const Image = styled.img`
  width: fit-content;
  margin-bottom: 20px;
`

export default function Footer() {
  return (
    <Container>
      <div className="container">
        <Wrapper className="footer__wrapper">
          <Item>
            <Image src={logo} alt="GDark logo" />
            <Copyright>&copy; {new Date().getFullYear()}</Copyright>
            <Disclaimer>
              Independent open-source project. Not affiliated with or endorsed
              by Grammarly Inc.
            </Disclaimer>
          </Item>
          <Item>
            <Title>Product</Title>
            <LinkItem
              href="https://gdark.netlify.app/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Website
            </LinkItem>
            <LinkItem
              href="https://github.com/bartzalewski/grammarly-dark"
              target="_blank"
              rel="noopener noreferrer"
            >
              Source code
            </LinkItem>
            <LinkItem
              href="https://headwayapp.co/grammarly-dark-changelog"
              target="_blank"
              rel="noopener noreferrer"
            >
              Changelog
            </LinkItem>
            <LinkItem
              href="https://bart-zalewski.gitbook.io/grammarly-dark/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Documentation
            </LinkItem>
            <LinkItem
              href="https://counter.dev/dashboard.html?user=bartzalewski&token=9Oc6dj0%2FRWOFRO2F"
              target="_blank"
              rel="noopener noreferrer"
            >
              Analytics
            </LinkItem>
          </Item>
          <Item>
            <Title>Download</Title>
            <LinkItem
              href="https://chrome.google.com/webstore/detail/grammarly-dark/noojmhngiheennhgaffkfboanjpbkpep?hl=en"
              target="_blank"
              rel="noopener noreferrer"
            >
              Google Chrome
            </LinkItem>
            <LinkItem
              href="https://addons.mozilla.org/en-US/firefox/addon/grammarly-dark/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Mozilla Firefox
            </LinkItem>
            <LinkItem
              href="https://microsoftedge.microsoft.com/addons/detail/grammarly-dark/kljjdbdffnbengiilkaiblpinbhfcfnc?hl=en-US%3Fhl%3Den-US"
              target="_blank"
              rel="noopener noreferrer"
            >
              Microsoft Edge
            </LinkItem>
          </Item>
          <Item>
            <Title>Support</Title>
            <LinkItem
              href="mailto:me@bartzalewski.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              Contact
            </LinkItem>
            <LinkItem
              href="https://github.com/bartzalewski/grammarly-dark/issues"
              target="_blank"
              rel="noopener noreferrer"
            >
              Submit issues
            </LinkItem>
          </Item>
          <Item>
            <Title>Social</Title>
            <LinkItem
              href="https://www.instagram.com/bartzalewskidev/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Instagram
            </LinkItem>
            <LinkItem
              href="https://www.facebook.com/bartzalewskidev"
              target="_blank"
              rel="noopener noreferrer"
            >
              Facebook
            </LinkItem>
            <LinkItem
              href="https://twitter.com/bartzalewskidev"
              target="_blank"
              rel="noopener noreferrer"
            >
              Twitter
            </LinkItem>
          </Item>
        </Wrapper>
      </div>
    </Container>
  )
}
